import { useQuery } from '@tanstack/react-query';

import { axios } from 'lib/axios';
import { donwloadFileFromURL } from 'features/frameworkAgreements/api/downloadFile';
import { qnaKey } from './queryKeys';

export const getQnaFile = async (resource, id, fileId) => {
  const {
    data: { data },
  } = await axios.get(`/api/${resource}/${id}/qna/files/${fileId}`);

  return data;
};

export const downloadQnaFile = async (resource, id, fileId) => {
  const file = await getQnaFile(resource, id, fileId);

  await donwloadFileFromURL(file.url, file.name);
};

export const useQnaFilePreview = (resource, id, fileId) =>
  useQuery({
    queryKey: qnaKey(resource, id, 'file', fileId),
    queryFn: () => getQnaFile(resource, id, fileId),
    enabled: !!fileId,
    staleTime: 2 * 60 * 1000,
    gcTime: 2 * 60 * 1000,
    select: ({ url, name, mime_type: mimeType }) => ({ url, name, mimeType: mimeType ?? '' }),
  });
